import { Link } from "react-router-dom";
import "./NewsPreview.css";
import Button from "../../components/Button";

const NewsPreview = (props) => {
  // rozcleneni datumu
  const date = new Date(props.date);
  const day = String(date.getDate()).padStart(2, "0");
  //prettier-ignore
  const month = date.toLocaleString("default", { month: "short" }).toUpperCase();

  return (
    <div className="col-lg-3 col-md-4 col-8 m-3 news-preview">
      <Link
        to={`/aktuality/detail/${props.id}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <div className="position-relative">
          <img src={props.image} alt={props.alt} className="w-100" />
          <div className="news-preview-date p-1 text-center">
            <h3>{day}</h3>
            <span className="news-preview-date-month">{month}</span>
          </div>
        </div>

        <div className="mt-2 p-3 news-preview-content">
          <h3>
            {props.name.slice(0, 40)}
            {props.name.length > 40 ? "..." : ""}
          </h3>
          <p className="pt-2">
            {props.overview.slice(0, 100)}
            {props.overview.length > 40 ? "..." : ""}
          </p>
        </div>
        <div className="text-center pb-3">
          <Button text="Číst dále" />
        </div>
      </Link>
    </div>
  );
};
export default NewsPreview;

